<template>
  <div>
    <b-card>
      <validation-observer ref="segRules" tag="form">
        <b-row>
          
          <b-col cols="12" class="mb-2">
            <h4 class="mb-0">
              Seguro <span class="text-success">{{ textoCobertura }}</span>
            </h4>
            <small class="text-muted">Ingrese la informacion del seguro</small>
          </b-col>
          

          <b-col md="6">
            <b-form-group label-for="v-segsalud">
              <label>Seguro Salud: <span class="text-danger">*</span></label>

              <validation-provider v-slot="{ errors }" name="seguroSalud" rules="required">
                <v-select
                  id="v-segSalud" 
                  :class="{ 'is-invalid': errors.length > 0 }" 
                  v-model="dataSeguro.seguroSalud"
                  :options="optsSegurosSaludFiltered" label="text" 
                />
                <div v-if="errors.length > 0" class="invalid-feedback">
                  El campo estado de salud es obligatorio
                </div>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="stDataCita.cobertura === '6'">
            <label for="">Seguro privado</label>
            <v-select 
              id="v-SeguroPrivado" 
              v-model="dataSeguro.seguroPrivado" 
              :options="optsSegurosPrivados"
              label="text" 
            />
          </b-col>

          <b-col md="12" v-if="stDataCita.cobertura === '1'">
            <b-row>
              <b-col md="4">
                <label for="historiaClinica">Historia Clinica</label>

                <InputNumber
                  id="historiaClinica"
                  v-model="dataSeguro.historiaClinica"
                  :disabled="disabledHistoriaClinica"
                />
                
              </b-col>

              <b-col>
                <b-button 
                  size="sm" 
                  variant="warning" 
                  class="mt-2"
                  @click="disabledHistoriaClinica = !disabledHistoriaClinica">
                  <i v-if="disabledHistoriaClinica" class="fa-solid fa-lock"/>
                  <i v-else class="fa-solid fa-lock-open"/>
                </b-button>
              </b-col>

            </b-row>
          </b-col>

        </b-row>
      </validation-observer>

      <hr class="my-2"/>

      <CitaTitulares
        v-if="dataSeguro.seguroSalud"
        esCrear
        @titulares-cita="getTitularesCita"
      />

    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect      from "vue-select";
import { BootstrapVue } from "bootstrap-vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { segurosService } from "@/views/admision/services";
import { getEstablecimientoLS, calculateAgeWithDateString } from "@/shared/helpers";
import { InputNumber }  from "@/shared/components";
import CitaTitulares    from "@/views/citas/components/RegistrarCitas/CitaTitulares.vue";
import { citasService } from "../../services";

export default {
  name: "CitaCobertura",

  components: {
    ValidationProvider,
    ValidationObserver,
    ...BootstrapVue.components,
    vSelect,
    CitaTitulares,
    InputNumber
  },

  

  data() {
    return {      
      
      tokenCita: null,
      dataSeguro: {
        seguroSalud: null,
        seguroPrivado: null,
        historiaClinica: null,
      },

      disabledHistoriaClinica: false,
      edadPaciente: null,

      optsSegurosSalud: [],
      optsSegurosPrivados: [],
      optsSegurosSaludFiltered: [],
      isInitializing: true,
    };
  },

  async created() {
    await this.loadDataInit();
    await this.loadDataSave();
    if (!this.tokenCita && this.isInitializing) this.isInitializing = false;
  },

  methods: {

    async loadDataSave() {
      
      this.tokenCita = this.$route.params.token;
      if(!this.tokenCita) return;

      const responseCita = await citasService.getByToken(this.tokenCita);

      if(!responseCita){
        console.error('Cita no encontrada');
        this.isInitializing = false;
        return;
      }

      const detalles = responseCita.detallescitaSet[0];
      const detallesSeguros = detalles?.detailsSeguro && JSON.parse(detalles?.detailsSeguro);

      // console.log('detallesObj', detallesSeguros);

      const responseSeguroMap = {
        seguroSalud: detallesSeguros?.seguroSalud,
        seguroPrivado: detallesSeguros?.seguroPrivado,
        historiaClinica: detallesSeguros?.historiaClinica,
      }

      this.dataSeguro = responseSeguroMap;
      const fechaNacimiento = responseCita?.paciente?.persona?.fechaNacimiento || null;
      if (fechaNacimiento) {
        this.edadPaciente = calculateAgeWithDateString(fechaNacimiento);
        await this.onLoadTiposSeguro(responseCita?.cobSeleccionada?.id, this.edadPaciente);
        if (!this.optsSegurosSaludFiltered.some(opt => opt.value === this.dataSeguro.seguroSalud?.value || opt.id === this.dataSeguro.seguroSalud?.id)) {
          const detalleActual = this.optsSegurosSalud.find(opt => opt.id === this.dataSeguro.seguroSalud?.id || opt.value === this.dataSeguro.seguroSalud?.value);
          if (detalleActual) this.optsSegurosSaludFiltered.unshift(detalleActual);
        }
      }
      this.$nextTick(() => {
        this.isInitializing = false;
      });
    },

    getTitularesCita(titulares) {
      this.$emit("titulares-cita", titulares);
    },

    async loadDataInit() {
      this.optsSegurosPrivados = await segurosService.getSegurosPrivados();
    },


    calcularEdadPaciente() {
      if(this.stDataPaciente) {
        const edadPaciente = calculateAgeWithDateString(this.stDataPaciente.persona.fechaNacimiento);
        this.edadPaciente = edadPaciente;

        this.onLoadTiposSeguro();
      }
    },

    getNumeroHistoriaClinica() {
      const historiaClinicaString = this.stDataPaciente?.numHistoriaClinica;
      const historiaClinicaObj    = JSON.parse(historiaClinicaString);
      const establecimiento       = getEstablecimientoLS();
      const historiaClinicaLocal  = historiaClinicaObj[establecimiento.id];

      this.dataSeguro.historiaClinica = historiaClinicaLocal;
      if(this.dataSeguro.historiaClinica) this.disabledHistoriaClinica = true;
    },

    async onLoadTiposSeguro(coberturaOverride = null, edadOverride = null) {

      const cobertura = coberturaOverride ?? this.tipoCobertura;
      const edad = edadOverride ?? this.edadPaciente;

      if (!cobertura) return;

      if(edad === null) {
        return;
      }

      const optsSegurosSalud = await segurosService.getTiposSegurosSalud();
      this.optsSegurosSalud = optsSegurosSalud;

      const codigosSeguroMenor = ["AG", "CA", "HJ", "MH", "AS"];
      const codigosIsspolMenor = ["AG", "MH"];
      const codigosIsspolMayor = ["CY", "SG", "MO"];

      const isIsspol = ["2", "3"].some((val) => cobertura === val);

      if (isIsspol) {
        this.optsSegurosSaludFiltered = edad < 18
          ? optsSegurosSalud.filter((s) => codigosIsspolMenor.includes(s.code))
          : optsSegurosSalud.filter((s) => codigosIsspolMayor.includes(s.code));
      }

      const isIees = ["1"].some((val) => cobertura === val);

      if (!isIees) return;

      this.optsSegurosSaludFiltered = edad < 18
        ? optsSegurosSalud.filter((s) => codigosSeguroMenor.includes(s.code))
        : optsSegurosSalud.filter((s) => !codigosSeguroMenor.includes(s.code));

    },

  },

  computed: {

    ...mapState({
      stDataCita     : state => state.citas?.ingresoCitas?.dataInfoCita,
      stDataPaciente : state => state.citas?.ingresoCitas?.dataInfoCita?.paciente,
    }),


    tipoCobertura() {
      return this.stDataCita ? this.stDataCita.cobertura : null
    },

    textoCobertura() {
      return this.tipoCobertura === '1' 
        ? 'IESS' 
        : this.tipoCobertura === '2' 
          ? 'ISSPOL' 
          : this.tipoCobertura === '3' 
            ? 'ISSFA'
            : this.tipoCobertura === '4'
              ? 'MSP'
              : this.tipoCobertura === '5'
                ? 'PARTICULAR'
                : this.tipoCobertura === '6'
                  ? 'PRIVADO'
                  : ''
    },

  },


  watch: {

    stDataPaciente(newValue) {
      if(!newValue) return;

      this.calcularEdadPaciente();
      this.getNumeroHistoriaClinica();
      
    },

    
    tipoCobertura() {
      this.onLoadTiposSeguro();
      if (this.isInitializing) return;
      this.dataSeguro = {
        seguroSalud: null,
        seguroPrivado: null,
        historiaClinica: null,
      };
      this.disabledHistoriaClinica = false;
    },

    dataSeguro: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setDataSeguro", { ...newValue });

        if(!newValue.seguroSalud){
          this.$store.commit("setDataTitulares", []);
        }
      },
    },
  }
};
</script>
